const FeesPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Membership Fees</h2>
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
        <thead>
          <tr className="bg-gray-100 border-b border-gray-200">
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Plan
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Duration
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Price
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Benefits
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          <tr>
            <td className="py-4 px-6 whitespace-nowrap text-lg font-semibold text-purple-700">
              Drop-in Class
            </td>
            <td className="py-4 px-6 whitespace-nowrap">1 Class</td>
            <td className="py-4 px-6 whitespace-nowrap">$20</td>
            <td className="py-4 px-6">Experience a single class.</td>
          </tr>
          <tr>
            <td className="py-4 px-6 whitespace-nowrap text-lg font-semibold text-indigo-700">
              Monthly Unlimited
            </td>
            <td className="py-4 px-6 whitespace-nowrap">1 Month</td>
            <td className="py-4 px-6 whitespace-nowrap">$120</td>
            <td className="py-4 px-6">
              Unlimited access to all regular classes.
            </td>
          </tr>
          <tr>
            <td className="py-4 px-6 whitespace-nowrap text-lg font-semibold text-green-700">
              3-Month Package
            </td>
            <td className="py-4 px-6 whitespace-nowrap">3 Months</td>
            <td className="py-4 px-6 whitespace-nowrap">$300</td>
            <td className="py-4 px-6">
              Save $60! Unlimited classes, 1 guest pass.
            </td>
          </tr>
          <tr>
            <td className="py-4 px-6 whitespace-nowrap text-lg font-semibold text-blue-700">
              Annual Membership
            </td>
            <td className="py-4 px-6 whitespace-nowrap">1 Year</td>
            <td className="py-4 px-6 whitespace-nowrap">$1000</td>
            <td className="py-4 px-6">
              Best value! Unlimited classes, 3 guest passes, 1 private session.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="mt-8 text-center text-gray-600">
      All prices are in USD. Special discounts may apply for students and
      seniors. Please inquire at the front desk.
    </p>
  </div>
);

export default FeesPage;
